import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { CardsCommentTemplate } from './variants/CardsComment'
import { CardsSlideTemplate } from './variants/CardsSlide'

const commentVariant = {
  ...productRowVariantForPath('cards', 2),
  Template: CardsCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('cards', 3),
  Template: CardsSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('cards')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
